// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Forms_wrapper__1g3x_","infoInput":"Forms_infoInput__13qXJ","inputWidth":"Forms_inputWidth__1jQMX"};